export const SET_OBSERVACAO = "PAYMENT/SET_OBSERVACAO"